import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {AdminClustersService} from '../../../Menus/AdminClusters/adminClusters.service';

@Component({
  selector: 'formly-field-ng-select',
  providers: [AdminClustersService],
  template: `
    <ng-select
      [items]="to.options"
      class="customSelect"
      [bindLabel]="labelProp"
      [bindValue]="valueProp"
      [multiple]="to.multiple"
      [virtualScroll]="true"
      [loading]="loading"
      [placeholder]="to.placeholder"
      [formControl]="formControl"
      (open)="opened(to.dependency)"
      [formlyAttributes]="field"
    >
    </ng-select>
    <div *ngIf="to?.fourEyesValue!=null" class="arrow-wrapper">
  <div class="arrow"></div>
  <ng-select  [items]="to.options"
    class="customSelect foureyes"
    disabled
    [bindLabel]="labelProp"
    [bindValue]="valueProp"
    [formlyAttributes]="field"
    [ngModel]="to.fourEyesValue"
    [multiple]="to.multiple"
    [virtualScroll]="true"
    [loading]="loading"
    [placeholder]="to.placeholder"
    (open)="opened(to.dependency)">
  </ng-select>
  </div>
  `,
})
export class FormlyFieldSelect extends FieldType {
  loading = false;

  constructor(
    public gridService: AdminClustersService,
    public visualsService: VisualsService,
  ) {
    super();
  }
  get labelProp(): string {
    if (this.field.key == 'bankId' || this.field.key == 'clientBranch' || this.field.key == 'bankBranch')  {
      return 'bankCd';
    } else if (this.field.key == 'productCode') {
      return 'productLabel';
    } else if (this.field.key == 'termsCode') {
      return 'termsDescription';
    } else {
      return 'text';
    }
  }
  get valueProp(): string {
    if (this.field.key == 'bankId' || this.field.key == 'clientBranch' || this.field.key == 'bankBranch')  {
      return 'bankId';
    } else if (this.field.key == 'productCode') {
      return 'productCode';
    } else if (this.field.key == 'termsCode') {
      return 'termsCode';
    } else {
      return 'id';
    }
  }

  opened(dependency) {
    if (dependency && dependency.dependentService) {
      this.loading = true;
      this.props.options = [];
      let dependentKeyVal =
        dependency.dependentKey && this.model[dependency.dependentKey]
          ? this.model[dependency.dependentKey]
          : '';
      this.gridService[dependency.dependentService](dependentKeyVal).subscribe({
        next: (data) => {
          let resp = data.data;
          var result = resp.map((el) => ({
            id: el.val,
            text: el.valLabel,
          }));
          this.props.options = result;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
    }
  }
}
